import { useParams } from "react-router-dom";

const blogData = [
  {
    id: 1,
    title: "8 Best Low Maintenance Plants For a Busy Home",
    image: "https://img.freepik.com/free-photo/close-up-person-s-hand-holding-plant-with-gardening-equipments-flower-peat-pot-peat-tray-wooden-table_23-2148044577.jpg?t=st=1736170865~exp=1736174465~hmac=667d46b4da09c9c736a6400538be6775d522003a7beaad8215016a2822eb1beb&w=1380",
    content: `
If you're juggling a hectic schedule but still want to enjoy the benefits of indoor greenery, low-maintenance plants are your best friends. These plants thrive with minimal attention, infrequent watering, and adapt well to indoor environments.

1. **Snake Plant (Sansevieria):** Practically indestructible and can survive with very little light and water.  
2. **ZZ Plant:** Tolerates low light and dry conditions, and adds a lush look to your space.  
3. **Pothos:** Grows quickly, survives low light, and purifies the air.  
4. **Spider Plant:** Hardy, easy to propagate, and safe for pets.  
5. **Peace Lily:** Needs only occasional watering and provides beautiful white blooms.  
6. **Rubber Plant:** Glossy leaves and tolerates low light.  
7. **Philodendron:** A classic trailing plant requiring little maintenance.  
8. **Cast Iron Plant:** As the name suggests, it’s nearly indestructible and great for dark corners.

These plants are ideal for beginners or anyone who loves plants but forgets to water regularly.
    `,
  },
  {
    id: 2,
    title: "Air Purifying Plants You Should Take Home Today",
    image: "https://img.freepik.com/free-photo/high-angle-man-working-eco-friendly-wind-power-project-with-papers-pencil_23-2148847791.jpg?t=st=1736170938~exp=1736174538~hmac=a059ec6ba39ef419d10707b973fc33912427dcbf0795a9f19bca2acc8620f582&w=900",
    content: `
Indoor air pollution is a growing concern. Fortunately, NASA studies have identified certain houseplants that effectively filter harmful toxins and improve air quality.

Top air-purifying plants include:

1. **Areca Palm:** A humidifier and air-purifier in one.  
2. **Spider Plant:** Removes carbon monoxide and formaldehyde.  
3. **Peace Lily:** Breaks down and neutralizes gases like benzene and formaldehyde.  
4. **Boston Fern:** Excellent at filtering indoor air and restoring moisture.  
5. **Aloe Vera:** Not just for burns—also absorbs benzene and formaldehyde.  
6. **English Ivy:** Reduces airborne mold and fecal particles.  
7. **Bamboo Palm:** Adds moisture and filters out toxins like benzene and trichloroethylene.

Keeping these plants in bedrooms or workspaces can help reduce headaches, fatigue, and dry skin caused by poor air quality.
    `,
  },
  {
    id: 3,
    title: "The Best Indoor Plants for a Healthier Home",
    image: "https://blog.woodenstreet.com/images/data/image_upload/1685795038Blog-banner.jpg",
    content: `
Indoor plants do more than just beautify your home—they contribute to a healthier, calmer, and more productive environment. They can reduce stress, boost your mood, and even help you sleep better.

Here are some top choices:

1. **Aloe Vera:** Emits oxygen at night, making it ideal for bedrooms.  
2. **Rubber Plant:** Improves air quality and is easy to grow.  
3. **Lavender:** Known for its calming scent, helps reduce stress and anxiety.  
4. **Snake Plant:** Great for filtering toxins and requires very little care.  
5. **Bamboo Palm:** Adds humidity and improves air quality.  
6. **Peace Lily:** Elegant and effective at cleansing air.  
7. **Fiddle Leaf Fig:** A stylish plant that adds boldness to any space.  
8. **Golden Pothos:** Fast-growing and excellent for hanging baskets or shelves.

Integrating these plants into your living space can enhance both your physical and mental well-being, making your home a healthier sanctuary.
    `,
  },
];

const BlogDetail = () => {
  const { id } = useParams();
  const blog = blogData.find((b) => b.id === parseInt(id));

  if (!blog) return <div className="p-4 text-red-500">Blog not found.</div>;

  return (
    <div className="max-w-3xl mx-auto p-4">
      <h1 className="text-3xl font-bold mb-4">{blog.title}</h1>
      <img
        src={blog.image}
        alt={blog.title}
        className="w-full h-72 object-cover rounded mb-4"
      />
      <div className="prose prose-lg text-gray-800 whitespace-pre-line">{blog.content}</div>
    </div>
  );
};

export default BlogDetail;
